import { render, staticRenderFns } from "./pindaanPengesahanTab.vue?vue&type=template&id=220b56b3&"
import script from "./pindaanPengesahanTab.vue?vue&type=script&lang=js&"
export * from "./pindaanPengesahanTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports